import React, { useState, useEffect } from 'react'
import { locale, loadMessages, formatMessage } from "devextreme/localization";
import moment from 'moment';
import { Card, CardHeader, CardBody, CardFooter, CardTitle, Row, Col } from "reactstrap";
import Select from 'react-select';
import { DataGrid, Column, SearchPanel, LoadPanel, Paging, Scrolling, Pager, Button } from 'devextreme-react/data-grid';
import { TextBox } from 'devextreme-react/text-box';
import NavBar from '../../navigation/NavBar';
import Empleados from '../../modals/Empleados';
import Detalle_Pases_Pendientes from '../../modals/Detalle_Pases_Pendientes';
import { Hypnosis } from "react-cssfx-loading";
import { getPases, msg } from '../../utils/api';
import { notificacionError, notificacionWarning } from '../../utils/alerts';

const options = [
    { value: '', label: 'Todos' },
    { value: '341', label: '1 - DEF. INTERCOMPAÑIA' },
    { value: '342', label: '2 - DEF. DEV. A PROVEEDOR' },
    { value: '343', label: '3 - DEF. CON CARGO' },
    { value: '344', label: '4 - DEF. OTROS' },
    { value: '345', label: '5 - TEMP. INTERCOMPAÑIA' },
    { value: '346', label: '6 - TEMP. REPARACION' },
    { value: '347', label: '7 - TEMP. TRABAJADOR' },
    { value: '348', label: '8 - TEMP. OTROS' }
]

export default function Pases_pendientes() {
    useEffect(() => {
        locale(navigator.language);
    }, [])
    const [modal, setModal] = useState(false);
    const [infoEmpleado, setInfoEmpleado] = useState({ id: 0, noEmpleado: 0, nombre: "" });
    const [detalleEmpleado, setDetalleEmpleado] = useState(null);
    const [modalDetalle, setModalDetalle] = useState(false);
    const [filtros, setFiltros] = useState({ empleado: "", tipoPase: "", grupo: "", folio: "", fechaPaseInicial: moment().format('YYYY-MM-DD'), fechaPaseFinal: moment().add(7, 'days').format('YYYY-MM-DD') });
    const [data, setData] = useState(null);
    const [dataUpdate, setDataUpdate] = useState(null);
    const [loading, setLoading] = useState(false);
    const [isEqual, setIsEqual] = useState(null);

    //METODO PARA FILTRAR
    const filtrar = () => {
        setLoading(true);
        if (filtros.empleado != "" || filtros.tipoPase != "" || filtros.folio != "" || (filtros.fechaPaseInicial != "" && filtros.fechaPaseFinal != "")) {
            getPases(filtros)
                .then(resp => {
                    if (resp.status === 200) {
                        if (resp?.data.length > 0) {
                            resp.data.forEach(e => {
                                e.Almacen = e.Almacen === null ? "Sin almacen" : e.Almacen;
                                e.Grupo = e.Grupo === null ? "Sin grupo" : e.Grupo;
                                //e.Documento = e.Documento.substr(2, 1);
                                let doc = null;
                                switch (e.Documento) {
                                    case "341":
                                        doc = "Def CIA";
                                        break;
                                    case "342":
                                        doc = "Def DEV";
                                        break;
                                    case "343":
                                        doc = "Def CGO";
                                        break;
                                    case "344":
                                        doc = "Def OTR";
                                        break;
                                    case "345":
                                        doc = "Tmp CIA";
                                        break;
                                    case "346":
                                        doc = "Tmp REP";
                                        break;
                                    case "347":
                                        doc = "Tmp TRA";
                                        break;
                                    case "348":
                                        doc = "Tmp OTR";
                                        break;
                                }
                                e.DocumentoLetra = doc;
                                e.NoDocumento = e.NoDocumento;
                                e.Fecha = e.Fecha === null ? "Sin fecha" : e.Fecha;
                                e.Estado = e.Estado;
                                e.TipoPase = e.TipoPase;
                                e.DescripcionPase = e.DescripcionPase === null ? "Sin descripción" : e.DescripcionPase;
                                e.Autoriza = e.autoriza === null ? "Sin autorización" : e.Autoriza;
                                e.FechaAutoriza = e.FechaAutoriza === null ? "Sin fecha" : e.FechaAutoriza;
                            });
                            setData(resp.data);
                            setLoading(false);
                        } else {
                            notificacionWarning("Sin pases por autorizar");
                            setData(null);
                            setLoading(false);
                        }
                    } else {
                        setLoading(false);
                        throw new Error(resp.statusText);
                    }
                })
                .catch(err => {
                    setLoading(false);
                    console.log(err);
                    notificacionError("Intentelo nuevamente, si el error persite favor de comunicarse con el administrador del sistema");
                });
        }
    }

    useEffect(() => {
        filtrar();
    }, [])

    useEffect(() => {
        const interval = setInterval(() => {
            let lista = JSON.parse(localStorage.getItem("listaAnterior"));
            //let lista = localStorage.getItem("listaAnterior");
            let contador = 0, send = true;
            getPases(filtros)
                .then(resp => {
                    if (resp.data.length > 0) {
                        if (lista != null) {
                            let data = [];
                            resp.data.map(e => { data.push(e.NoDocumento) });
                            send = arrayEquals(data, lista) ? false : true;
                            console.log(arrayEquals(data, lista), data, lista, send);
                        }
                        if (send) {
                            msg(resp.data)
                                .then(resp2 => {
                                    let data = [];
                                    resp.data.map(e => { data.push(e.NoDocumento) });
                                    localStorage.setItem("listaAnterior", JSON.stringify(data));
                                })
                                .catch(err => {
                                    console.log(err);
                                });
                        }
                    } else {
                        localStorage.removeItem("listaAnterior");
                    }
                    console.log("SE EJECUTO EN: ", moment().format("hh:mm"));
                });
        }, 300000);
        //300000
        //3600000
        return () => {
            localStorage.removeItem("listaAnterior");
        };
    }, []);

    //VALIDAR DOS ARREGLOS SI SON IDENTICOS
    function arrayEquals(a, b) {
        return Array.isArray(a) &&
            Array.isArray(b) &&
            a.length === b.length &&
            a.every((val, index) => val === b[index]);
    }

    useEffect(() => {
        setData(dataUpdate);
    }, [dataUpdate])

    useEffect(() => {
        saveFiltros('empleado', infoEmpleado.noEmpleado)
    }, [infoEmpleado])

    const saveFiltros = (type, e) => {
        setFiltros({ ...filtros, [type]: e });
    }

    const allowedPageSizes = [5, 10, 'all'];

    const AbrirModal = () => {
        setModal(true);
    }
    const CerrarModal = (e) => {
        setModal(e);
    }

    const AbrirModalDetalle = () => {
        setModalDetalle(true);
    }
    const CerrarModalDetalle = (e) => {
        setModalDetalle(e);
    }

    const onSelectionChanged = (e) => {
        const data = e.row.data;
        //e.row.data.Documento = parseInt(`34${e.row.data.Documento}`);
        setDetalleEmpleado(data);
        AbrirModalDetalle();
    }

    const limpiarEmpleado = () => {
        setInfoEmpleado({ id: 0, noEmpleado: 0, nombre: "" })
    }

    return (
        <>
            <NavBar />
            <div className="container mt-2">
                <Row>
                    <Col>
                        <Card className="card-stats">
                            <CardBody>
                                <Row>
                                    <Col sm={{ size: 4, order: 1 }}>
                                        <label className="col-form-label fw-bold">Tipo de Pase</label>
                                        <Select
                                            placeholder="Seleccionar tipo de pase"
                                            name="Pase"
                                            options={options}
                                            className="basic-multi-select"
                                            classNamePrefix="Seleccionar Pase"
                                            onChange={(e) => saveFiltros('tipoPase', e.value)}
                                        />
                                    </Col>
                                    <Col sm={{ size: 4, order: 2 }}>
                                        <label className="col-form-label fw-bold">Por Pase De:</label>
                                        <input disabled type="date" className="form-control" onChange={(e) => saveFiltros('fechaPaseInicial', e.target.value)} value={filtros.fechaPaseInicial} />
                                    </Col>
                                    <Col sm={{ size: 4, order: 3 }}>
                                        <label className="col-form-label fw-bold">A:</label>
                                        <input type="date" className="form-control" onChange={(e) => saveFiltros('fechaPaseFinal', e.target.value)} value={filtros.fechaPaseFinal} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={{ size: 2, order: 1 }}>
                                        <button className="btn btn-primary" onClick={AbrirModal}>Empleado</button>
                                    </Col>
                                    <Col sm={{ size: 5, order: 1 }}>
                                        <label className="col-form-label fw-bold">Empleado:</label>
                                        <TextBox
                                            value={infoEmpleado.nombre}
                                            showClearButton={true}
                                            readOnly
                                            onChange={(e) => saveFiltros('empleado', e.event.currentTarget.value)}
                                        />
                                        <button className="btn btn-danger" onClick={limpiarEmpleado}>Limpiar Empleado</button>
                                    </Col>
                                    <Col sm={{ size: 5, order: 2 }}>
                                        <label className="col-form-label fw-bold">Folio:</label>
                                        <input type="number" className="form-control" onChange={(e) => saveFiltros('folio', e.target.value)} />
                                    </Col>
                                </Row>
                            </CardBody>
                            <CardFooter>
                                <div className="mt-2 text-end">
                                    <button className="btn btn-secondary" onClick={filtrar}>Filtrar</button>
                                </div>
                            </CardFooter>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Card>
                            <CardHeader>
                                <CardTitle tag="h4">Pases Pendientes</CardTitle>
                            </CardHeader>
                            <CardBody>
                                {loading ?
                                    <Hypnosis width="100px" height="100px" style={{ margin: "0 auto" }} />
                                    :
                                    <>
                                        <DataGrid
                                            dataSource={data}
                                            columnMinWidth={50}
                                            showBorders={true}
                                            columnHidingEnabled={true}
                                            allowColumnResizing={true}
                                            columnResizingMode={true}
                                            columnAutoWidth={true}
                                            wordWrapEnabled={true}
                                        >
                                            <SearchPanel
                                                visible={true}
                                                width={240}
                                                placeholder="Buscar..." />
                                            <LoadPanel enabled={true} />
                                            {/* <Selection mode="single" /> */}
                                            <Scrolling rowRenderingMode='virtual'></Scrolling>
                                            <Paging defaultPageSize={10} />
                                            <Pager
                                                visible={true}
                                                allowedPageSizes={allowedPageSizes} />
                                            <Column dataField="DocumentoLetra" caption="Documento" />
                                            <Column dataField="NoDocumento" caption="No. Pase" />
                                            <Column dataField="Grupo" caption="Grupo" />
                                            <Column dataField="Fecha" dataType="date" caption="Fecha" />
                                            <Column dataField="NoEmpleado" caption="No. ID" />
                                            <Column dataField="NombreEmpleado" caption="Responsable" />
                                            <Column dataField="TipoPase" caption="Tipo" />
                                            <Column dataField="DescripcionPase" caption="Descripción" />
                                            {/* <Column dataField="Autoriza" />
                                            <Column dataField="FechaAutoriza" dataType="date" caption="Fecha de Autorizacion"/> */}
                                            <Column type="buttons">
                                                <Button
                                                    text="Detalle"
                                                    onClick={onSelectionChanged}
                                                />
                                            </Column>
                                        </DataGrid>
                                        <Empleados abrirModal={modal} cerrarModal={CerrarModal} infoEmpleado={setInfoEmpleado} />
                                        <Detalle_Pases_Pendientes abrirModal={modalDetalle} cerrarModal={CerrarModalDetalle} detalle={detalleEmpleado} refresh={filtros} dataUpdate={setDataUpdate} />
                                    </>
                                }
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    )
}
